/** 全局动态或项目动态投影。其它路由不要走这一套外壳。 */
export function isActivityPath(pathname: string): boolean {
  if (pathname === '/activity' || pathname.startsWith('/activity/')) return true
  return /\/projects\/[^/]+\/activity\/?$/.test(pathname)
}
